import { PropsWithChildren, ReactNode } from 'react'
import { tv } from 'tailwind-variants'
import Card from './Card'

const tileStyles = tv({
  slots: {
    base: 'text-base shrink-0',
    header: 'whitespace-nowrap',
  },
  variants: {
    size: {
      small: {
        base: 'py-1 px-3 min-w-16 flex-col whitespace-nowrap items-center text-center',
        header: 'uppercase text-xs opacity-70',
      },
      medium: {
        base: 'py-2 px-4 text-sm',
        header: 'mb-2 pb-1 border-b font-bold block',
      },
    },
  },
})

interface Props {
  title: ReactNode
  className?: string
  innerClassName?: string
  dataPresent?: boolean
  size?: keyof typeof tileStyles.variants.size
  headerRight?: ReactNode
}

const DashboardTile = ({
  children,
  title,
  className = '',
  innerClassName = '',
  size = 'small',
  dataPresent = true,
  headerRight,
}: PropsWithChildren<Props>) => {
  const { base, header } = tileStyles({ size })

  return (
    <Card className={`${base()} ${className}`}>
      {headerRight ? (
        <div
          className={`flex items-center flex-wrap justify-between gap-2 ${header()}`}
        >
          <span>{title}</span>
          {headerRight}
        </div>
      ) : (
        <span className={header()}>{title}</span>
      )}
      <div
        className={`${innerClassName} duration-300 ${
          dataPresent ? 'opacity-100' : 'opacity-0'
        } transition-opacity`}
      >
        {children}
      </div>
    </Card>
  )
}

export default DashboardTile
